<!-- <div class=" mb-5 mb-xl-8">
  <div class="card-body py-3">
<div class="d-flex justify-content-end mb-5">
  <div (click)="goto()" class="btn font-weight-bolder btn-primary" >
                <span class="svg-icon svg-icon-3 svg-icon-gray-500 me-1">
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.0759 3H4.72777C3.95892 3 3.47768 3.83148 3.86067 4.49814L8.56967 12.6949C9.17923 13.7559 9.5 14.9582 9.5 16.1819V19.5072C9.5 20.2189 10.2223 20.7028 10.8805 20.432L13.8805 19.1977C14.2553 19.0435 14.5 18.6783 14.5 18.273V13.8372C14.5 12.8089 14.8171 11.8056 15.408 10.964L19.8943 4.57465C20.3596 3.912 19.8856 3 19.0759 3Z" fill="currentColor"></path>
                    </svg>
                </span>
    {{"rapport.filter" | translate}}
  </div>
</div>
    <div class="d-flex align-items-baseline">
      <div class="">
        <form class="w-375px me-10 position-relative mb-3" autocomplete="off">
        <span [inlineSVG]="'./assets/media/icons/duotune/general/gen021.svg'"
              class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-3"></span>
          <input type="text" class="form-control  ps-10 border ps-13" name="search"
                 [value]="searchService.searchKeyworld.value" [placeholder]="'MenuDashboard.searchHolder' | translate"
                 data-kt-search-element="input" (keyup)="search($event)" /> -->
          <!-- [(ngModel)]="searchQ" -->
          <!-- (input)="search($event.target.value)" -->
        <!-- </form>
      </div>
      <div class="w-375px me-10">
        <div  class="h-40px ">
          <ng-container *ngIf="listCategories$ | async as listTag; else loadingusers">
            <lcms-select-filter [isLoading]="categoriesLoad"  (SearchItem)="searchTag($event)" (ScrollToEnd)="tagsloadMor($event)" [title]="'catalogue.tags' | translate" [items]="listTag" (selectedItemsChange)="onSelectedCateChange($event)" >
            </lcms-select-filter>
          </ng-container>
          <ng-template #loadingusers>
            <ngx-shimmer-loading
              [width]="'100%'"
              [height]="'20px'"
            ></ngx-shimmer-loading>
          </ng-template>
        </div>

        <ng-container *ngIf="selectedCategories ">

                            <span *ngFor="let item of selectedCategories  " class="badge badge-light-primary bg-body-secondary mb-2 me-2 mt-3 p-3 w-auto">{{ item?.label }}
                              <a class="cursor-pointer" (click)="removecate(item)">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                    </svg>
                                </a>
                            </span>
        </ng-container>
      </div>
      <div class="w-375px">
        <div  class="h-40px ">
          <lcms-select-filter  (SearchItem)="searchType($event)"  [title]="'type' | translate" [items]="typeCatalogue" (selectedItemsChange)="onSelectedTypeChange($event)" >
          </lcms-select-filter>
        </div>
        <ng-container *ngIf="selectedtype ">
                            <span *ngFor="let item of selectedtype  " class="badge badge-light-primary bg-body-secondary mb-2 me-2 mt-3 p-3 w-auto">{{ item?.label }}
                              <a class="cursor-pointer" (click)="removeType(item)">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                    </svg>
                                </a>
                            </span>
        </ng-container>
      </div> -->
<!--      <div *ngIf="resultsCategories" class="w-100 d-flex justify-content-start align-items-start mt-8">-->
<!--        <h2>{{resultsCategories[0].nbr}} résultat trouvés </h2>-->
<!--        <div class="ms-16 d-flex gap-8 justify-content-start align-items-end">-->
<!--          <a role="button" class="search-category-menu-item fw-bolder " *ngFor="let item of resultsCategories"-->
<!--            [class.active]="item.key===searchService.getCheckedCategory()" (click)="handleActive(item)">-->
<!--            {{'search.'+item.title | translate}} ({{item.nbr}})</a>-->
<!--        </div>-->
<!--      </div>-->
    <!-- </div>
</div>

</div> -->

<ng-container *ngIf="isLoading | async">
  <div class="progress-bar" [class.invisible]="!isLoading">
    <div class="progress-bar-value"></div>
  </div>
</ng-container>
<!-- results part -->
<ng-container *ngIf="results$ |async as results">
  <ng-container *ngIf="type$ | async as types">
    <ng-container *ngIf="results['catalogue'].length>0 || results['ressources'].lenght>0 ; else noData">
    <ng-container *ngIf="types.length>0 && types.length<=2 ; else default">
    <ng-container *ngFor="let type of types ">
      <ng-container *ngFor="let key of getKeys(results)">
        <ng-container *ngIf="['',key].includes(type.value) && results[key].length>0"
                      lcmsDynamicSearchComponent [cmpName]="key" [cmpData]="results[key]"
                      [showDetails]="searchService.getCheckedCategory()===key">

        </ng-container>
    </ng-container>
  </ng-container>
    </ng-container>
    </ng-container>
</ng-container>
    <ng-template #default>
  <ng-container *ngFor="let key of getKeys(results)">
    <ng-container *ngIf="['',key].includes(searchService.getCheckedCategory()) && results[key].length>0"
      lcmsDynamicSearchComponent [cmpName]="key" [cmpData]="results[key]"
      [showDetails]="searchService.getCheckedCategory()===key">

    </ng-container>
  </ng-container>
    </ng-template>
  <ng-template #noData>
    <div class="d-flex flex-column align-items-center p-20">
      <span class="fa-3x mt-20 fw-lighter text-gray-700 text-nowrap" >{{'faq.elsatiquesearch'|translate}}</span>
      <span class="fw-lighter text-gray-700 fs-2hx"> {{"faq.suggestionsterms" | translate}} </span>
<!-- <span class="fs-2 fw-lighter text-muted"></span>-->
    </div>
  </ng-template>
</ng-container>
